<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" v-if="level !== 'STORE'">
      <el-tab-pane label="绑定设备订单" name="0"></el-tab-pane>
      <el-tab-pane label="区域设备订单" name="1" v-if="level === 'AREA'"></el-tab-pane>
    </el-tabs>
    <com-order-search typeOfView="partner" @search="handleSearch"></com-order-search>
    <com-order-list
      typeOfView="partner"
      :default-params="defaultParams"
      ref="table"
    ></com-order-list>
  </div>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: ''
    }
  },
  watch: {
    code: {
      handler(val) {
        if (val) {
          this.defaultParams.partnerCode = val
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      defaultParams: {},
      activeName: '0',
      searchColumn: [
        {
          label: '网点名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '绑定时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  },
  methods: {
    handleClick() {
      if (this.activeName === '1') {
        this.defaultParams.areaPartnerCode = this.code
        delete this.defaultParams.partnerCode
        this.$refs.table.init()
        return
      }

      this.defaultParams.partnerCode = this.code
      delete this.defaultParams.areaPartnerCode
      this.$refs.table.init()
    },
    handleSearch(val) {
      this.$refs.table.search(val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
